goog.provide('el8.ptdata.ptProblems');

goog.require('el8.appservice.notifier');
goog.require('el8.data.allergies');
goog.require('el8.data.base');
goog.require('el8.data.imos');
goog.require('el8.model.base');
goog.require('el8.ptdata.model.PatientItemSet');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.shared.util.billing');
goog.require('el8.template.ptdata.ptProblems');
goog.require('el8.uiwidget.alert');

el8.ptdata.ptProblems = (function() {
    var _isXWalkNotifierDismissed = null;

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    // Need to populate the problem's icd9Id list and the el8.data cache combining two sources
    // 1. the legacy icd9s and 2. the icd9 lists from IMOCodes
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        spec.imoIds = spec.imoIds || spec.imo_ids || [];

        // Both this problem's legacy and IMO-term icd9s, we'll hydrate them here to
        // avoid asynchronous getById calls for them later
        spec.icd9Ids = [];
        spec.bothIcd9Codes = [];
        spec.bothIcd9Descs = [];

        var hasOutdatedDx = false;
        var timeNowMs = Date.now();

        // 9's from IMO terms
        _.each(spec.imos, function (imo) {
            spec.icd9Ids = spec.icd9Ids.concat(imo.icd9_ids);
            spec.bothIcd9Codes = spec.bothIcd9Codes.concat(imo.icd9_codes);
            spec.bothIcd9Descs = spec.bothIcd9Descs.concat(imo.icd9_descriptions);

            // Cache imo and append id
            el8.data.imos.create(imo);
            spec.imoIds.push(imo.id);
        
            // Determine if IMO term has any explicitly non-billable ICD-10 codes (as of today)
            if (imo.icd10_effective_dates) {
                imo.icd10_effective_dates.map(function (period) {
                    var startDate = period[0];
                    var endDate = period[1];
                    var isCodeInvalid = el8.shared.util.billing.isCodeNonBillable(startDate, endDate, timeNowMs);
                    if (isCodeInvalid) {
                        hasOutdatedDx = true;
                    }
                });
            }
        });

        // Problem with deleted IMOs needs user to remove or replace non-billable DX codes
        spec.dxOutdated = hasOutdatedDx;

        // 9's from "legacy" icd9s
        if (spec.icd9_ids && spec.icd9_ids.length) {
            spec.icd9Ids = spec.icd9Ids.concat(spec.icd9_ids);
            spec.bothIcd9Codes = spec.bothIcd9Codes.concat(spec.icd9_codes);
            spec.bothIcd9Descs = spec.bothIcd9Descs.concat(spec.icd9_descriptions);
        }
        spec.showLastAddressedDate = (spec.status !== 'Resolved' && spec.have_hcc &&
                                      (!spec.last_addressed_date || el8.service.tz.newTzDate(spec.last_addressed_date).year > el8.service.tz.now().year));

        spec.showLastFullyAddressedDate = (spec.status !== 'Resolved' && spec.have_hcc &&
                                      (!spec.last_fully_addressed_date || el8.service.tz.newTzDate(spec.last_fully_addressed_date).year < el8.service.tz.now().year));

        // Convert to json and hydrate icd9s
        var icd9s = _.map(_.zip(spec.icd9Ids, spec.bothIcd9Codes, spec.bothIcd9Descs), function(icd9) {
            return {id: icd9[0], code: icd9[1], description: icd9[2]};
        });

        el8.data.icd9Codes.create(icd9s);
        this.parent.populate.call(this, spec);
    };

    _class.makePatientItem();

    _class.addStringProperty('description', true);
    _class.addStringProperty('details', true);

    _class.addIntProperty('year', true);
    _class.addDate('startDate', true);
    _class.addIntProperty('rank', true);
    _class.addStringProperty('status', true);
    _class.addDate('resolvedDate', true);
    _class.addProperty('imoLastAddressedDates', true);
    _class.addStringProperty('lastFullyAddressedDate', true);
    _class.addBoolean('showLastFullyAddressedDate', true);

    // IMO mapping contains non-billable or deprecated DX codes as of today
    _class.addBoolean('dxOutdated', true);

    _class.addIcd9s();
    _class.addImos();
    _class.addProperty('snomedIds', true, []);
    _class.addProperty('nonImoIcd9Codes', true, []);

    /**
     * HELPER METHODS
     */
    // The default summary for a problem referenced in a note.
    // We'll use this one for notes that support structured IMOs
    // (e.g., 2 col) and nonvisit notes
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.ptProblems.noteSummary({
            description: this.getDescription()
        }).el8_unescape();
    };
    // This note summary shoves the ICD-10s into the text
    // description fo the note. We use it when referencing into
    // unstructured assessment sections (e.g., SOAP notes)
    _class.prototype.getNoteSummaryWithCodes = function() {
        return el8.template.ptdata.ptProblems.noteSummary({
            description: this.getDescription(),
            withCodes: true,
            imos: this.getImoCodeObjs().map(el8.model.toSoyMapFn)
        }).el8_unescape();
    };
    // This note summary also includes the synopsis ("details")
    // as text and potentially includes codes: we use it when
    // the user specifically references "problem w/ details"
    // into a section without sub-bullets
    _class.prototype.getNoteSummaryWithDetails = function(withCodes) {
        return el8.template.ptdata.ptProblems.noteSummary({
            description: this.getDescription(),
            withCodes: withCodes,
            imos: this.getImoCodeObjs().map(el8.model.toSoyMapFn),
            withDetails: true,
            details: this.getDetails()
        }).el8_unescape();
    };
    _class.prototype.setAsResolved = function() {
        this.setStatus('Resolved');
        this.setResolvedDate(el8.service.tz.today());
    };
    _class.prototype.setAsControlled = function() {
        this.setStatus('Controlled');
        this.setResolvedDate(null);
    };
    _class.prototype.setAsActive = function() {
        this.setStatus('Active');
        this.setResolvedDate(null);
    };
    _class.prototype.getIcd9Codes = function() {
        // Override this getter to use getIcd9CodeObjs
        var r =  _.map(this.getIcd9CodeObjs(), function (icd9Obj) {
            return icd9Obj.getCode();
        });
        return _.uniq(r);
    };
    _class.prototype.getSnomedCodes = function() {
        return this.getSnomedIds().map(function(id) {
            return el8.data.snomedCodes.getById(id).getCode();
        });
    };
    _class.prototype.getSnomedCodeObjs = function() {
        return this.getSnomedIds().map(function(id) {
            return el8.data.snomedCodes.getById(id);
        });
    };
    _class.prototype.asMap = function() {
        return this.parent.asMap.call(this, true);
    };
    _class.prototype.asSoyMap = function(propsToExclude) {
        var mapped = this.parent.asSoyMap.call(this, propsToExclude);

        mapped['imos'] = this.getImoIds().map(function(id) {

            // Display all active problems even if the deprecated IMO has been deleted from database cache
            var imo = el8.data.imos.getByIdIncludingDeleted(id);

            // Filter non-existent IMOs (e.g. discovered as deprecated THIS session) to prevent render crash
            // NOTE: Page reload will load IMO without issue into "deleted" frontend cache and renders appropriately
            if (!imo) { return; }

            return imo.asSoyMap();
        }).filter(function (imo) {
            // FUTURE: How can we preserve a deprecated IMO discovered as outdated in current session 
            // (completely removed from frontend cache) and/or how should they render? e.g. "UNKNOWN"
            return imo; 
        });

        mapped['needsXWalk'] = Boolean(!this.getImoIds().length && this.getNonImoIcd9Codes().length);

        return mapped;
    };
    var that = new el8.ptdata.model.PatientItemSet({
        model: function(spec) { return new _class(spec); },
        sortFn: function(a, b){ return a.getRank()-b.getRank(); },
        urlLoad: function() { return el8.service.urls.get('ptProblems'); },
        saveFn: function(item, successCallbackFn, errorCallbackFn) {
            // Validate the year
            if (item.getStartDate() > el8.service.tz.today() || item.getStartDate() < el8.service.tz.newTzDate(1900, 0, 1)) {
                el8.uiwidget.alert('Patient problem year must be between 1900 and today');
                return false;
            }

            el8.appservice.notifier.notify('Patient problem being saved...');

            $.el8_ajax({
                url: el8.service.urls.get('ptProblems', [item]),
                type: 'POST',
                data: JSON.stringify(item.asMap()),
                success: function(data) {
                    el8.ptdata.ptProblems.setDocumented(data.is_documented);
                    if (item.getId()) {
                        el8.ptdata.ptProblems.updateItemId(item, data.item.id);
                    }
                    item.populate(data.item);
                    el8.appservice.notifier.notify('Patient problem saved.');
                    if (successCallbackFn ) { successCallbackFn(); }
                },
                error: errorCallbackFn
            });
        },
        deleteFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Patient problem being deleted...');
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('ptProblems', [item]),
                success: function() {
                    if (successCallbackFn) { successCallbackFn(item); }
                    el8.appservice.notifier.notify('Patient problem deleted.');
                    // Remove to allow for mapping updates
                    _.each(item.getImoCodeObjs(), function (imo) {
                        el8.data.imos.remove(imo);
                    });
                }
            });
        }
    });

    that.getAllActive = function() {
        return that.sorted().filter(function(p) {
            return p.getStatus() === 'Active';
        });
    };

    // return a list of ICD9s that can be fed to emptyQueryData in a mindreader
    that.getActiveIcd9Autocomplete = function() {
        return _.flatten(that.getAllActive().map(function(ptProblem) {
            var icd9CodeObjs = ptProblem.getIcd9CodeObjs();
            return icd9CodeObjs.map(function(icd9CodeObj) {
                return { id: icd9CodeObj.getId(), code: icd9CodeObj.getCode(), description: icd9CodeObj.getDescription()};
            });
        }));
    };
    /**
     * Get autocomplete map of all relevant IMO terms for patient from visits + problems:
     *   1. IMOs from unsigned notes (if we're including unsigned notes)
     *   2. IMOs from the last signed note (based on bullet order)
     *   3. IMOs from the LHS (in the order the problems appear in the LHS)
     */
    that.getActiveImoAutocomplete = function(includeUnsignedNotes, includeDeletedImos) {

        var relevantVisits = [];
        // Unsigned notes, then,
        if (includeUnsignedNotes) {
            relevantVisits = relevantVisits.concat(
                el8.ptdata.visitNotes.getUnsigned(), el8.ptdata.tempVisitNotes.all()
            );
        }

        // The most recent signed note; we attempt to cache this
        // even if it's below the fold (in appchart.js)
        var lastSignedVisit = el8.ptdata.visitNotes.getSigned()[0];
        if (lastSignedVisit) { relevantVisits.push(lastSignedVisit); }

        // Extract IMOs from the bullets of the visits we collected
        var relevantVisitImoObjs = relevantVisits.map(function(note) {
            var imos = [];
            el8.util.consts.IMO_VISIT_SECTIONS.forEach(function(section) {
                var bulletSet = note.getBulletSets()[section.toUpperCamel()];
                imos = imos.concat(bulletSet.sorted().map(function(b) {
                    return b.getImoCodeObjs();
                }));
            });
            return imos;
        });

        // And extract IMOs from our active problems
        var activeProblemImoObjs = that.getAllActive().map(function(ptProblem) {
            return ptProblem.getImoCodeObjs(includeDeletedImos);
        });

        // Finally, flatten (because each problem/bullet had its own array)
        // then de-duplicate the list (on IMO code)
        var allImoObjs = _.flatten(relevantVisitImoObjs.concat(activeProblemImoObjs));
        allImoObjs = _.uniq(allImoObjs, false, function(imoCodeObj) {
            return imoCodeObj.getCode();
        });

        var finalAutocompleteMap = allImoObjs.map(function(imoCodeObj) {
            return imoCodeObj.asAutocompleteMap();
        });
        return finalAutocompleteMap;
    };

    that.hasIcd9Codes = function() {
        var all = that.all();
        for (var i=0; i<all.length; i++) {
            if (all[i].getIcd9Codes().length) { return true; }
        }
        return false;
    };

    // Set of methods to handle "None" vs. Not Documented
    that.saveAsDocumented = function() {
        $.el8_ajax({
            url: el8.service.urls.get('patientProblemDocumentation'),
            type: 'POST',
            success: function(data) {
                that.setDocumented(true);
                that.trigger(EVENTS.UPDATED);
            }
        });
    };
    that.deleteAsDocumented = function() {
        $.el8_ajax({
            url: el8.service.urls.get('patientProblemDocumentation'),
            type: 'DELETE',
            success: function(data) {
                that.setDocumented(false);
                that.trigger(EVENTS.UPDATED);
            }
        });
    };
    that.isDocumentedAsNone = function() {
        return !that.all().length && that.isDocumented();
    };
    that.isNotDocumented = function() {
        return !that.all().length && !that.isDocumented();
    };
    that.getDocumentedAsNoneSummary = function() {
        return that.isDocumentedAsNone() ?
            el8.template.ptdata.ptProblems.documentedAsNoneSummary().el8_unescape() : '';
    };

    // Check for xwalk notifer dismissal status
    that.isXWalkNotifierDismissed = function() {
        if (_isXWalkNotifierDismissed === null) {
            $.el8_ajax({
                url: el8.service.urls.get('patientProblemGetXWalkNotifier'),
                async: false,
                success: function(data) { _isXWalkNotifierDismissed = data; }
            });
        }
        return _isXWalkNotifierDismissed;
    };

    that.dismissXWalkNotifier = function(callbackFn) {
        $.el8_ajax({
            url: el8.service.urls.get('patientProblemDismissXWalkNotifier'),
            type: 'POST',
            success: function(data) {
                _isXWalkNotifierDismissed = data;
                if(callbackFn) { callbackFn(); }
                return data;
            }
        });
    };

    return that;
})();
